import styled, { css } from 'styled-components';
import Typography from '../../typography';
/**
 * ThankYou intro
 */
export const thankYouIntroStyles = () => css `
	margin-bottom: 0;
`;
export const ThankYouIntro = styled(Typography).attrs({ variant: 'body-text' }) `
	${thankYouIntroStyles}
`;
